import { fullWidth } from '@components/frame';
import { getLinkingModalConfig, isWeb } from '@helpers';
import { BOTTOM_SHEET_TOP_OFFSET, SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';
import { ScaleFunction } from '@components/operatorPanel/interfaces';

export const getFinishJobModalPopupConfig = (scale: ScaleFunction) => ({
  ...getLinkingModalConfig(scale),
  useFullHeight: !isWeb,
  offsetTop: isWeb ? scale(18) : scale(BOTTOM_SHEET_TOP_OFFSET / 2),
  width: Math.min(fullWidth, scale(860)),
  borderRadius: SCREEN_BORDER_RADIUS,
});
